export default "__VITE_ASSET__Cv4U86zh__"